const platforms = [
  "SolidWorks API",
  "AutoCAD API",
  "Revit API",
  "Inventor API",
];
const languages = ["C#", ".NET", "AutoLISP", "iLogic", "COM API"];
const highlighted = [
  "SolidWorks API",
  "AutoCAD API",
  "Revit API",
  "Inventor API",
  "C#",
  ".NET",
];

function About() {
  return (
    <section className="cdh-section" id="about">
      <div className="cdh-section__inner cdh-about">
        <div className="cdh-about__left">
          <div className="cdh-eyebrow">About</div>
          <h2 className="cdh-section__h">Prasath</h2>
          <div className="cdh-about__body">
            <p>
              I'm a <strong>CAD Automation Engineer</strong> based in Chennai
              with 8+ years of experience building production-grade automation
              tools for real engineering companies across SolidWorks, AutoCAD,
              Revit, and Inventor.
            </p>
            <blockquote>
              "Most mechanical engineers are stuck at the drafting board. Not
              because they lack skill. Because no one showed them there is a way
              out."
            </blockquote>
            <p>
              I've seen engineers with 5 years of SolidWorks experience get
              passed over for automation roles because they couldn't write a
              single script. The knowledge gap is real, but the learning path
              does not have to be painful.
            </p>
            <p>
              I teach only what's necessary. No noise. No generic C# tutorials.
              Just the specific concepts and API patterns that map directly to
              real automation work. The skills companies actually hire for.
            </p>
            <p>
              I also <strong>review resumes for free.</strong> DM me on LinkedIn
              or comment "CAD" on any of my posts. I will tell you exactly what
              to learn next.
            </p>
          </div>
        </div>

        <div className="cdh-about__right">
          <div className="cdh-sidebar-block">
            <div className="cdh-sidebar-lbl">Platforms</div>
            <div className="cdh-tags">
              {platforms.map((p) => (
                <span
                  key={p}
                  className={`cdh-tag ${highlighted.includes(p) ? "cdh-tag--hi" : ""}`}
                >
                  {p}
                </span>
              ))}
            </div>
          </div>
          <div className="cdh-sidebar-block">
            <div className="cdh-sidebar-lbl">Languages</div>
            <div className="cdh-tags">
              {languages.map((l) => (
                <span
                  key={l}
                  className={`cdh-tag ${highlighted.includes(l) ? "cdh-tag--hi" : ""}`}
                >
                  {l}
                </span>
              ))}
            </div>
          </div>
          <div className="cdh-sidebar-block">
            <div className="cdh-sidebar-lbl">Experience</div>
            <p className="cdh-sidebar-text">
              8+ years building production automation tools · PSG College of
              Technology · Chennai, Tamil Nadu
            </p>
          </div>
          <div className="cdh-sidebar-block">
            <div className="cdh-sidebar-lbl">Find me</div>
            <a
              href="https://linkedin.com/in/prasath-r-5584343b7"
              target="_blank"
              rel="noreferrer"
              className="cdh-sidebar-link"
            >
              LinkedIn →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;
